import { createSelector } from 'reselect';

import { AppState } from '../../../../../../store/models/app-state';

const getSupplierDetail = (state: AppState) => state.contactsAndOrganizations.suppliers.supplierDetail;

export const supplierEmployeeSelector = createSelector(getSupplierDetail, state => state.employees.employees);

export const supplierHasBonusConditionErrorSelector = createSelector(
    getSupplierDetail,
    state => state.employees.hasBonusConditionError
);
